import {
  FlatActionList,
  FlatActionListItem,
  ProductThumbnail,
  View,
} from "@towersystems/roam-common-native";
import { Product } from "@towersystems/roam-common/lib/generated-types";

export interface ChildVariantsListProps {
  variants: Product[];
  onAllPress: (variant: Product) => void;
  disabled?: boolean;
  onAddNewPress?(): void | undefined;
}

export const ChildVariantsList = ({
  variants,
  onAllPress,
  disabled,
  onAddNewPress,
}: ChildVariantsListProps) => {
  if (variants.length === 0) {
    return null;
  }

  let items: FlatActionListItem[] = variants.map((variant) => ({
    key: variant.id,
    title: variant.displayName,
    onPress: () => onAllPress(variant),
    subTitle: variant.stockNumber,
    disabled,
    trailingAccessory: (
      <ProductThumbnail size="small" imageUrl={variant.image?.path} />
    ),
  }));

  if (!disabled) {
    items.push({
      key: "add_new",
      title: "Add new variant",
      subTitle: "Create a new variant for this product",
      onPress: onAddNewPress,
      isAction: true,
    });
  }

  return <FlatActionList items={items} />;
};
